import React from 'react';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="w-full bg-ink-800 px-4 py-14 sm:px-5 sm:py-20" data-id="element-187" data-mp="20rytduv6tzic">
      <div className="mx-auto max-w-5xl" data-id="element-188" data-mp="1n00pbygc2tt1">
        <h2 className="text-center text-xl font-extrabold uppercase text-white sm:text-3xl" data-id="element-189" data-mp="1myzf1w756bcd">
          ❤️ Más mayoristas que ya lo tienen
        </h2>

        <ul className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-190" data-mp="1d1unfguj1no6">
          {testimonials.map(item => <li key={item.initials} data-id="element-191" data-mp="1i0xtn4m8tzxq">
              <figure className="h-full rounded-2xl border border-white/10 bg-ink-900 p-6" data-id="element-192" data-mp="1i1z5vcezwsh1">
                <div className="flex items-center gap-3" data-id="element-193" data-mp="141y6y2iajv47">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-500 text-sm font-bold text-ink-900" data-id="element-194" data-mp="143j1vt8ipg2l">
                    {item.initials}
                  </span>
                  <div data-id="element-195" data-mp="32gsq76s2resf">
                    <span className="block text-xs text-yellow-400" data-id="element-196" data-mp="32hat2m98sr9b">
                      ⭐⭐⭐⭐⭐
                    </span>
                    <span className="block text-sm font-extrabold text-white" data-id="element-197" data-mp="2v09o0odx324n">
                      {item.name}
                    </span>
                    <span className="block text-xs text-gray-400" data-id="element-198" data-mp="2q0n9mbmcrfu9">
                      {item.meta}
                    </span>
                  </div>
                </div>
                <blockquote className="mt-5 text-sm leading-relaxed text-gray-300" data-id="element-199" data-mp="2zst17k8ozv8x">
                  {item.quote}
                </blockquote>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}